import React, { useEffect } from 'react'

import { UseFormReturn } from 'react-hook-form'

import { ZoneRequestDTO } from '@/features/zones/Create/Create'

import { PersonalInfoSubStep } from './PersonalInfoSubStep'

interface NewLocationStepProps {
	form: UseFormReturn<ZoneRequestDTO>
	onFormDataChange: (data: Partial<ZoneRequestDTO>) => void
}

const NewLocationStep: React.FC<NewLocationStepProps> = ({ form }) => {
	const { control, watch, setValue } = form

	// Initialize store object if it doesn't exist
	useEffect(() => {
		const store = watch('store')
		if (!store) {
			setValue('store', {
				account_id: watch('account_id'),
				name: '',
				country: '',
				type: 'own',
				address: '',
				phone_country_code: '',
				phone_number: '',
				email: '',
				city: '',
				zip_code: '',
				manager: '',
				timezone: '',
				additional_information: '',
				id_type: '',
				id_number: '',
			} as any)
		}
	}, [watch, setValue])

	return (
		<div className="space-y-6">
			<PersonalInfoSubStep control={control} />
		</div>
	)
}

export default NewLocationStep
